// Workspace setup nudge for the Client Portal sidebar — hidden once every required setup step is complete.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight, Sparkles } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SetupNudge({ headers }) {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API}/api/setup/status`, { headers }).then((r) => setS(r.data)).catch(() => setS(null)); }, [headers]);
  if (!s || s.complete) return null;
  const pct = Math.round((100 * s.done) / s.total);
  return (
    <Link to="/setup" data-testid="ob-setup-nudge" className="group block rounded-2xl border border-amber-200/80 bg-gradient-to-br from-amber-50 to-white p-4 shadow-sm transition hover:border-amber-400 hover:shadow-md">
      <div className="flex items-center justify-between gap-2">
        <p className="text-[10px] font-black uppercase tracking-[0.16em] text-amber-700 flex items-center gap-1.5"><Sparkles className="w-3 h-3" /> Workspace setup</p>
        <span className="text-[11px] font-black tabular-nums text-amber-800">{s.done}/{s.total}</span>
      </div>
      <div className="mt-2.5 h-1.5 rounded-full bg-amber-100 overflow-hidden"><div className="h-full rounded-full bg-amber-500 transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
      {s.next && <p className="mt-2.5 text-xs text-slate-700 leading-snug"><span className="font-bold">Up next:</span> {s.next.title}</p>}
      <p className="mt-2 inline-flex items-center gap-1 text-[11px] font-bold text-[#15133A] group-hover:gap-1.5 transition-all">Finish setup <ArrowRight className="w-3 h-3" /></p>
    </Link>
  );
}
